import { mean, omit } from 'lodash';
import { defaultLessonProgress, lessonProgressWithRecord } from './LessonProgress';
export function courseProgressPercent(c) {
    const total = c.lessons.length;
    const passed = c.lessons.filter(({ passed }) => passed).length;
    return total != 0 ? passed / total : 0;
}
export function defaultCourseProgress(course) {
    const lessons = course.lessons.map(defaultLessonProgress);
    const passed = lessons.every(({ passed }) => passed);
    const rating = passed == false ? 0 : mean(lessons.map(({ rating }) => rating)) ?? 0;
    return {
        courseId: course.id,
        lessons, rating, passed
    };
}
export function courseProgressWithRecord(progress, record) {
    const lessons = progress.lessons.map((l) => l.lessonId == record.lessonId
        ? lessonProgressWithRecord(l, omit(record, 'lessonId'))
        : l);
    const passed = lessons.every(({ passed }) => passed);
    const rating = passed == false ? 0 : mean(lessons.map(({ rating }) => rating)) ?? 0;
    return {
        courseId: progress.courseId,
        lessons, rating, passed
    };
}
//# sourceMappingURL=CourseProgress.js.map